<template>
  <div>
    <main class="d-flex justify-content-center mb-5 flex-wrap gap-5">
      <section
        class="cards-info rounded-2 overflow-hidden"
        v-for="(plan, i) in plans"
        :key="i"
      >
        <section class="prices text-center p-5">
          <h4 class="fw-bold mb-3">{{ plan.title }}</h4>
          <h1 class="fw-bold mb-2">{{ getCurrency }}{{ plan.price }}</h1>

          <v-btn
            color="#10182f"
            @click="getSelectedPlan(plan)"
            class="text-decoration-none p-2 rounded-2 text-white fw-bold d-block m-auto"
            >Get started</v-btn
          >
        </section>

        <section class="ml-8 features bg-white">
          <ul class="list-unstyled">
            <li
              class="d-flex gap-2 mb-3 align-items-center"
              v-for="feature in plan.features"
            >
              <v-icon>mdi-check</v-icon>
              <strong>{{ feature }}</strong>
            </li>
          </ul>
        </section>
      </section>
    </main>
  </div>
</template>

<script>
export default {
  props: {
    selectedDocObj: {
      default: () => ({}),
    },
    pricingPlans: {
      default: () => ({}),
    },
    priceCategories: {
      default: () => ({}),
    },
  },
  computed: {
    getCurrency() {
      return this.$store.getters.getCurrency;
    },
  },
  data: () => ({
    plans: [],
  }),
  mounted() {
    const plans = Object.values(this.pricingPlans);
    plans.forEach((plan) => {
      if (
        plan.title.includes("asic") &&
        this.priceCategories &&
        this.priceCategories[this.selectedDocObj.priceTier]
      ) {
        plan.price = this.priceCategories[this.selectedDocObj.priceTier].price;
      }
    });
    this.plans = plans;
  },
  methods: {
    getSelectedPlan(plan) {
      this.$emit("plan-selected", plan);
    },
  },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Mulish:wght@400;700&display=swap");

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: "Mulish", sans-serif !important;
  background-color: #f7f8fc !important;
  color: #10182f !important;
}

main {
  margin-top: 5rem;

  .cards-info {
    max-width: 380px;
    width: 95%;
    box-shadow: 0 10px 10px darken(#f7f8fc, 15%);

    @media (max-width: 807px) {
      max-width: unset;
    }

    .prices {
      background-color: darken(#f7f8fc, 10%);

      h1 {
        font-size: 2.875rem;
      }

      a,
      a:visited {
        background-color: #10182f;
        max-width: 160px;
        width: 100%;
      }
    }
  }
}
</style>
